// The maintainer's GitHub login. This account may use the development-only
// controls exposed by the plan and tone routes.
export const MAINTAINER_GITHUB_LOGIN = 'jamesbhobbs';

interface ExternalAccountLike {
  readonly provider: string;
  // Optional + nullable so both the server `User` (string | null) and the
  // client `UserResource` (string | null | undefined) shapes are accepted.
  readonly username?: string | null;
}

interface UserLike {
  readonly externalAccounts: readonly ExternalAccountLike[];
}

/**
 * The login of the user's linked GitHub account, or undefined when there is no
 * GitHub account or it carries no username. Clerk uses `github` or the legacy
 * `oauth_github`; exact matching prevents a custom provider ending in
 * `github` from being treated as GitHub. Pure, so it works on both the server
 * `User` and the client `UserResource`.
 */
export function githubLoginOf(user: UserLike): string | undefined {
  return (
    user.externalAccounts.find(
      (account) =>
        account.provider === 'github' || account.provider === 'oauth_github',
    )?.username ?? undefined
  );
}

/** GitHub logins are case-insensitive. */
export function isMaintainerLogin(login: string | null | undefined): boolean {
  return login?.toLowerCase() === MAINTAINER_GITHUB_LOGIN;
}

/**
 * True when `user` signed in with the maintainer's GitHub account — not a Clerk
 * profile username, nor a same-named account from another provider.
 */
export function isMaintainerUser(user: UserLike): boolean {
  return isMaintainerLogin(githubLoginOf(user));
}
